// extracted by mini-css-extract-plugin
export default {"ctaSection":"lxwIkTS8Fk66g9R7Kk4v","h1":"cvipVN25fH9eFGWWEu4P","ctaButton":"mZJHwWxQuuUrIKBphU88"};